import { redirect } from 'react-router';
import type { LoaderFunctionArgs } from 'react-router';
import { consumeHandoff, verifyEmailToken } from '../lib/handoff';
import { currentSession, syncSupabaseProfile } from '../lib/supabase';

/**
 * One entry point for every way a session can arrive:
 *   - tokens in the fragment, handed over by the signup page
 *   - a one-time token in the query, from an emailed link
 *   - a session already in storage
 * Whichever it is, it ends on the dashboard.
 */
export async function verifyLoader({ request }: LoaderFunctionArgs): Promise<Response> {
  const url = new URL(request.url);
  const tokenHash = url.searchParams.get('token_hash') || url.searchParams.get('token');
  const type = url.searchParams.get('type') || 'magiclink';

  let session = await consumeHandoff();

  if (!session && tokenHash) session = await verifyEmailToken(tokenHash, type);
  if (!session) session = await currentSession();
  if (!session) return redirect('/signed-out');

  // A profile that fails to write is worth logging, never worth blocking entry.
  await syncSupabaseProfile(session).catch(error => console.error('Profile sync failed:', error));

  return redirect('/');
}
